import { inject, Injectable } from '@angular/core';
import { DropdownOption } from '@shared/form/form-combobox/form-combobox.model';
import { ScreenOrGroup, ScreenOrGroupListResponse } from '@admin/screen/model/screen-group.model';
import { TranslateConfigService } from '@core/translate-config.service';
import { getDeviceTypeLabels } from './statistics.utils';

@Injectable()
export class ScreenOrGroupFilterService {
  private readonly translate = inject(TranslateConfigService);
  private readonly deviceTypeLabels = getDeviceTypeLabels(this.translate);
  private items: ScreenOrGroup[] = [];

  readonly map = new Map<number, ScreenOrGroup>();
  options: DropdownOption[] = [];
  params = { totalCount: 0, pageNumber: 0, pageSize: 10 };

  handleResponse(response: ScreenOrGroupListResponse, pageNumber: number): void {
    const newItems = response.items ?? [];
    this.items = pageNumber === 0 ? newItems : [...this.items, ...newItems];
    newItems.forEach(item => this.map.set(item.deviceInfo[0]?.id, item));
    this.options = this.items.map(item => ({
      id: item.deviceInfo[0]?.id,
      name: item.name,
      label: item.isGroup
        ? this.translate.instant('screens.screenGroupBtn')
        : (this.deviceTypeLabels[item.deviceInfo[0]?.deviceType] ?? ''),
    }));
    this.params = { ...this.params, totalCount: response.totalCount, pageNumber };
  }

  getSelectedIds(selectedIds: number[]): number[] {
    return selectedIds
      .filter(id => id !== -1)
      .flatMap(id => this.map.get(id)?.deviceInfo.map(d => d.id) ?? []);
  }

  clear(): void {
    this.items = [];
    this.map.clear();
    this.options = [];
    this.params = { totalCount: 0, pageNumber: 0, pageSize: this.params.pageSize };
  }
}
